import React from "react";
import styled from "styled-components";

export const Heading = styled((props) => <h1 {...props} />).attrs((props) => ({
  automationid:
    props.automationid ||
    `SalesLead_h1_${props?.automationidattr?.replace(/ /g, "")}_1"`,
}))`
  font-family: "Roboto" !important;
  font-weight: 700 !important;
  color: #282828;
  font-size: ${(props) => (props.size ? props.size : "32px")};
  text-align: "left";

  @media only screen and (min-width: 320px) and (max-width: 450px) {
    font-weight: 500;
    font-size: 20px;
  }
`;
